<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  export let index = 0;

  onMount(() => {
    if (index !== 0) window.scrollTo(0, document.body.scrollHeight);
  });
</script>

<div class="card" transition:fade>
  <slot />
</div>

<style>
  .card {
    border-radius: 15px;
    background-color: #fff;
    box-shadow: rgba(99, 99, 99, 0.3) 0px 2px 8px 0px;
    padding: 1rem;
    margin-top: 10px;
    margin-bottom: 30px;
    width: 100%;
    max-width: 400px;
    width: 90%;
  }
</style>
